import "./App.css";
import './App.css'
import TodoList from "./Components/TodoList";

function App() {
  return (
    <div className="todo-app">
      <h1>TO-DOs</h1>
      <TodoList />
    </div>
  );
}

export default App;
